import React from "react";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle } from "@ionic/react";
import "./GliderDocumentInvalidityOverlay.css";

function formatDue(d) {
  if (!d) return "—";
  if (typeof d === "string" && d.length >= 10) {
    const [y, m, day] = d.slice(0, 10).split("-");
    if (y && m && day) return `${day}.${m}.${y}`;
  }
  return String(d);
}

/** Seskupí řádky API podle kluzáku (letadla). */
function groupByGlider(rows) {
  const order = [];
  const byKey = new Map();
  for (const row of rows) {
    const g = row.glider;
    const key = g?.id != null ? `id:${g.id}` : `anon:${g?.registration ?? ""}|${g?.name ?? ""}`;
    if (!byKey.has(key)) {
      byKey.set(key, { glider: g, documents: [] });
      order.push(key);
    }
    byKey.get(key).documents.push(row);
  }
  return order.map((k) => byKey.get(k));
}

export function GliderDocumentInvalidityOverlay({ rows, onDismiss }) {
  if (!rows || rows.length === 0) {
    return null;
  }

  const grouped = groupByGlider(rows);

  return (
    <div className="glider-doc-invalidity-backdrop" role="dialog" aria-modal="true" aria-labelledby="glider-doc-invalidity-title">
      <IonCard className="glider-doc-invalidity-panel">
        <IonCardHeader>
          <IonCardTitle id="glider-doc-invalidity-title">Dokumenty kluzáků k pozornosti</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <p className="glider-doc-invalidity-intro">
            Zobrazeny jsou neplatné dokumenty a dokumenty, u kterých brzy vyprší platnost nebo dojde k limitu
            (podle nastavení upozornění u typu kontroly). Týká se aeroklubových kluzáků a vašich vlastních kluzáků.
          </p>
          <ul className="glider-doc-invalidity-list">
            {grouped.map((group) => {
              const g = group.glider;
              const gliderKey = g?.id != null ? `g-${g.id}` : `g-${g?.registration}-${g?.name}`;
              const first = group.documents[0];
              return (
                <li key={gliderKey} className="glider-doc-invalidity-glider-block">
                  <div className="glider-doc-invalidity-glider-header">
                    <strong>{g?.name || "?"}</strong>
                    {g?.registration ? (
                      <span className="glider-doc-invalidity-reg"> ({g.registration})</span>
                    ) : null}
                  </div>
                  {first?.lastLogBookItem && (
                    <div className="glider-doc-invalidity-meta glider-doc-invalidity-logbook-summary">
                      Poslední řádek knihy ke dni {formatDue(first.lastLogBookItem.day)}: nálet{" "}
                      {first.lastLogBookItem.totalHours ?? 0} h {first.lastLogBookItem.totalMinutes ?? 0} min, starty{" "}
                      {first.lastLogBookItem.totalCount ?? 0}
                    </div>
                  )}
                  <ul className="glider-doc-invalidity-doc-list">
                    {group.documents.map((row, docIdx) => {
                      const isWarn = row.checkState === "WARN";
                      return (
                      <li
                        key={row.documentCheck?.id ?? `${gliderKey}-doc-${docIdx}`}
                        className={`glider-doc-invalidity-doc-item${isWarn ? " glider-doc-invalidity-doc-item--warn" : " glider-doc-invalidity-doc-item--bad"}`}
                      >
                        <div className="glider-doc-invalidity-doc">
                          {isWarn ? (
                            <span className="glider-doc-invalidity-badge glider-doc-invalidity-badge--warn">Upozornění</span>
                          ) : (
                            <span className="glider-doc-invalidity-badge glider-doc-invalidity-badge--bad">Neplatné</span>
                          )}
                          {" "}
                          Dokument: <strong>{row.documentType?.name || "—"}</strong>
                        </div>
                        {row.documentCheck?.dueDate != null && (
                          <div className="glider-doc-invalidity-meta">
                            Platnost do: {formatDue(row.documentCheck.dueDate)}
                          </div>
                        )}
                        {row.invalidityReasons && row.invalidityReasons.length > 0 && (
                          <ul className="glider-doc-invalidity-reasons">
                            {row.invalidityReasons.map((r, i) => (
                              <li key={i}>{r}</li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>
          <IonButton expand="block" onClick={onDismiss}>
            Rozumím, pokračovat
          </IonButton>
        </IonCardContent>
      </IonCard>
    </div>
  );
}
